export default __webpack_public_path__ + "static/media/blog3.aeae4a3f.png";